export function planPath(studentId: string, schoolYear?: string): string {
  const base = `/plans/${encodeURIComponent(studentId)}`;
  return schoolYear ? `${base}/${encodeURIComponent(schoolYear)}` : base;
}
